"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingRuleComplementaryByItem = void 0;
const _1 = require("./");
const PricingRuleComplementary_1 = require("./PricingRuleComplementary");
/**
 * Pricing Rule: ComplementaryByItem
 *
 * This rule defines the maximum number of a specified item a customer
 * can have for free. For example, a burrito product blueprint
 * (base price $12.40) comes with a topping category with three options,
 * lettuce (unit price $2.50), cheese (unit price $2.50) and guac ($3.00).
 * It also comes with a ComplementaryByItem pricing rule on guac saying the
 * complementary quantity is 1. Given such a blueprint, it would cost $12.40
 * which is the base price if the customer added 0-1 share of guac. On the
 * other hand, it would cost $15.40 which is the base price plus the unit
 * price of guac if the customer added 2 shares of guac as it exceeded the
 * complementary quantity this pricing rule had on guac by 1, hence the extra
 * charge of $3.00.
 */
class PricingRuleComplementaryByItem extends PricingRuleComplementary_1.PricingRuleComplementary {
    constructor(data) {
        super(data);
        this.name = _1.TPricingRuleName.complementaryByItem;
        if (data) {
            this.productId = data.productId;
            this.quantity = data.quantity;
        }
    }
    serialize() {
        return Object.assign(Object.assign({}, super.serialize()), { productId: this.productId });
    }
    static unserialize(data) {
        const newPricingRuleComplementaryByItem = new this();
        newPricingRuleComplementaryByItem.productId = data.productId;
        newPricingRuleComplementaryByItem.quantity = data.quantity;
        return newPricingRuleComplementaryByItem;
    }
    calculateDiscount(productAvailability, selectedProducts) {
        let discount = 0;
        const selectedProduct = selectedProducts.find(sp => sp.product.productId === this.productId);
        if (selectedProduct) {
            const applicableQuantity = Math.min(selectedProduct.quantity, this.quantity);
            discount = applicableQuantity * selectedProduct.product.retailPrice;
        }
        return discount;
    }
    /**
     * Check that the given product matches this item pricing rule
     */
    matchesPricingRule(product) {
        return product.productId === this.productId;
    }
}
exports.PricingRuleComplementaryByItem = PricingRuleComplementaryByItem;
//# sourceMappingURL=PricingRuleComplementaryByItem.js.map